import { Box } from "ui/box/box";
import { mergeSx } from "ui/merge-sx";
import { Pagination } from "ui/pagination/pagination";
import { Select } from "ui/select/select";
import { DEFAULT_ROWS_PER_PAGE_OPTIONS } from "ui/table-pagination/table-pagination.helpers";
import {
  GROUP_SX,
  PAGE_SIZE_SELECT_SX,
  ROOT_SX,
} from "ui/table-pagination/table-pagination.styles";
import { type TablePaginationProps } from "ui/table-pagination/table-pagination.types";
import { useTablePagination } from "ui/table-pagination/use-table-pagination";
import { Typography } from "ui/typography/typography";

export const TablePagination = ({
  count,
  page,
  rowsPerPage,
  onPageChange,
  onRowsPerPageChange,
  rowsPerPageOptions = DEFAULT_ROWS_PER_PAGE_OPTIONS,
  showDisplayedRows = true,
  id,
  sx,
  ref,
}: TablePaginationProps) => {
  const {
    pageSizeSelectName,
    pageCount,
    displayedRows,
    pageSizeOptions,
    selectedPageSize,
    hasPageSizeSelect,
    handlePageChange,
    handleRowsPerPageChange,
  } = useTablePagination({
    count,
    page,
    rowsPerPage,
    rowsPerPageOptions,
    onPageChange,
    onRowsPerPageChange,
  });

  return (
    <Box id={id} ref={ref} sx={mergeSx(ROOT_SX, sx)}>
      <Box sx={GROUP_SX}>
        {showDisplayedRows && (
          <Typography color="text.primary" component="p" variant="body2">
            {displayedRows}
          </Typography>
        )}
        {pageCount > 0 && (
          <Pagination count={pageCount} page={page + 1} onChange={handlePageChange} />
        )}
      </Box>
      {hasPageSizeSelect && (
        <Box sx={GROUP_SX}>
          <Typography color="text.primary" component="p" variant="body2">
            View
          </Typography>
          <Select
            ariaLabel="Rows per page"
            selectName={pageSizeSelectName}
            disableClearable
            size="small"
            sx={PAGE_SIZE_SELECT_SX}
            options={pageSizeOptions}
            value={selectedPageSize}
            onChange={handleRowsPerPageChange}
          />
        </Box>
      )}
    </Box>
  );
};
